import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path d="M15 17.75a6 6 0 1 1-9.75-4.687V5a3.75 3.75 0 0 1 7.5 0v8.063A6 6 0 0 1 15 17.75m-1.5 0a4.5 4.5 0 0 0-1.93-3.694.75.75 0 0 1-.32-.618V5a2.25 2.25 0 0 0-4.5 0v8.438a.75.75 0 0 1-.32.614 4.5 4.5 0 1 0 7.07 3.698" />
    <path
      fill="#BA4C21"
      d="M11.545 19.337a3 3 0 0 0-1.795-4.493V5a.75.75 0 0 0-1.5 0v9.844a3 3 0 1 0 3.295 4.493M14.656 8.047a.75.75 0 0 1 .192-1.042c.975-.673 2.501-.673 3.476 0 .469.325 1.301.325 1.774 0a.75.75 0 0 1 .851 1.234 3.25 3.25 0 0 1-3.476 0c-.469-.326-1.301-.326-1.774 0a.75.75 0 0 1-1.043-.192M20.098 10.005c-.469.325-1.301.325-1.774 0-.975-.673-2.501-.673-3.476 0a.75.75 0 1 0 .851 1.234c.469-.326 1.301-.326 1.774 0a3.25 3.25 0 0 0 3.476 0 .75.75 0 0 0-.851-1.234"
    />
  </>
);

const Weather36Colored = Icon('weather-36-colored', svgContents);

export default Weather36Colored;
